import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      '& > a': {
        marginRight: 10,
        marginBottom: SMALL_MARGIN,
      },
      '& > div': {
        marginRight: 10,
        marginBottom: SMALL_MARGIN,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
  }),
);
export default useStyles;
